<template>
  <div class="gameIntro_content">
    <div class="intro_page" v-if="true">
      <van-swipe
        :autoplay="lbwrapSwipeAutoplay"
        class="my_swiper"
        ref="lbwrapSwipe"
      >
        <van-swipe-item
          v-for="(item, index) in headArr"
          :key="index"
          @click="detailClick(item.id)"
        >
          <img :src="item.img" />
          <div class="head_info">
            <span class="title">{{ item.title }}</span>
            <span class="info"
              >{{ item.memberNickName }} · {{ item.createTime }}</span
            >
          </div>
          <i class="point_con"></i>
        </van-swipe-item>
      </van-swipe>
      <div
        class="swiper-prev"
        @click="swipePrev"
        v-if="!$store.state.isMobile"
      ></div>
      <div
        class="swiper-next"
        @click="swipeNext"
        v-if="!$store.state.isMobile"
      ></div>
      <navList />
      <component
        v-for="(item, index) in componentsList"
        :key="index"
        :is="item.type"
        :title="item.title"
        :list="item.list"
      ></component>
      <div class="gameIntro_bottom"></div>
      <sideBox v-if="$padFalg != 'other'" />
    </div>
    <img
      class="no_show"
      v-else
      src="../../../../assets/img/gl/guidepage-icon.png"
      alt=""
      style="margin: 0 auto"
    />
  </div>
</template>

<script>
import get from '@/api/get';
import getDateDiff from '@/assets/js/time';
import introBox from './components/introBox.vue';
import cultureBox from './components/cultureBox.vue';
import videoBox from './components/videoBox.vue';
import navList from './components/navList.vue';
import sideBox from './components/sideBox.vue';
export default {
  components: {
    introBox,
    cultureBox,
    videoBox,
    navList,
    sideBox
  },
  data() {
    return {
      lbwrapSwipeAutoplay: 3000,

      headArr: [
        // {
        //   id: '',
        //   img: '//snspic.zlongame.com/1705460260139/sns/topics/banner/1671421307851.png',
        //   title: '机组人员首轮招募启动！请加入我们，建设米赫玛岛',
        //   memberNickName: '情报妹',
        //   createTime: '2天前'
        // }
      ],
      //{title:'',type:'',list:[]}
      componentsList: [] //type:1 introBox   7 cultureBox   5 videoBox
    };
  },
  computed: {},
  watch: {
    '$store.state.token': function () {
      if (this.$store.state.token) {
        this.getPageInfo();
        this.getBanner();
      }
    }
  },
  methods: {
    swipePrev() {
      this.$refs.lbwrapSwipe.prev();
      this.lbwrapSwipeAutoplay = 0;
      setTimeout(() => {
        this.lbwrapSwipeAutoplay = 3000;
      });
    },
    swipeNext() {
      this.$refs.lbwrapSwipe.next();
      this.lbwrapSwipeAutoplay = 0;
      setTimeout(() => {
        this.lbwrapSwipeAutoplay = 3000;
      });
    },
    getBanner() {
      get.getGlGameintroBanner().then((res) => {
        this.headArr = res.data.data.banners.map((item) => {
          return {
            id: item.id,
            title: item.title,
            img: item.thumbnail,
            createTime: getDateDiff(item.createTime),
            memberNickName: item.memberNickName
          };
        });
      });
    },
    getPageInfo() {
      get.getGlGameintro({ locate: 'f_gl_mid' }).then((res) => {
        res.data.data.forEach((item) => {
          let obj = {};
          obj.title = item.ftrName;
          switch (item.vmode) {
            case 1:
              obj.type = 'introBox';
              obj.list = item.topics.map((child) => {
                return {
                  id: child.id,
                  img: child.thumbnail,
                  title: child.title,
                  desc: child.description
                };
              });
              break;
            case 3:
              obj.type = 'videoBox';
              obj.list = item.topics.map((child) => {
                return {
                  id: child.id,
                  img: child.thumbnail,
                  title: child.title
                };
              });
              if (this.$store.state.isMobile) {
                if (obj.list.length % 2 == 1) {
                  obj.list.pop();
                }
              }
              break;
            case 7:
              obj.type = 'cultureBox';
              obj.list = item.sub.map((child) => {
                let career = {};
                career.career = child.ftrName;
                career.listArr = child.topics.map((childitem) => {
                  return {
                    id: childitem.id,
                    img: childitem.thumbnail,
                    title: childitem.title,
                    desc: childitem.description
                  };
                });
                return career;
              });
              break;
          }
          this.componentsList.push(obj);
        });
      });
    },
    detailClick(id) {
      let _path = '../topicPage/?topicId=' + id + '&isGame=true';
      this.$router.push({
        path: _path
      });
    }
  },
  created() {
    console.log('222');
    if (this.$store.state.token) {
      this.getPageInfo();
      this.getBanner();
    }
  },
  mounted() {}
};
</script>
<style lang='scss' scoped>
.ipad.gl .gameIntro_content {
  width: 100%;
  .gameIntro_bottom {
    width: 100%;
    height: 0.2rem;
  }
  .my_swiper {
    .van-swipe-item {
      img {
        width: 100%;
        height: 2.5rem;
      }
    }
  }
}
.gameIntro_content {
  width: 6.88rem;
  position: relative;
  .my_swiper {
    width: 100%;
    height: auto;
    position: relative;
    .van-swipe-item {
      display: flex;
      flex-direction: column;
      img {
        width: 100%;
        height: 2rem;
      }
      .head_info {
        width: 100%;
        height: 1.32rem;
        background: #ffffff;
        box-shadow: 0 0.03rem 0.05rem 0 rgba(235, 235, 235, 0.55);
        border-radius: 0 0 0.2rem 0.2rem;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        padding: 0 0.2rem;
        box-sizing: border-box;
        .title {
          width: 100%;
          font-weight: 500;
          color: #2b2b2b;
          font-size: 0.32rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 0.1rem;
          margin-top: 0.16rem;
        }
        .info {
          font-weight: 400;
          color: #808492;
          font-size: 0.24rem;
        }
      }
      .point_con {
        // height: 0.28rem;
      }
    }
  }
  .gameIntro_bottom {
    width: 100%;
    height: 1.8rem;
  }
}
</style>
<style  lang='scss'>
.no_show {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 3rem;
}

.gl .gameIntro_content {
  .van-swipe__indicators {
    height: 0.07rem;
    top: 3.1rem;
    .van-swipe__indicator {
      width: 0.07rem;
      height: 0.07rem;
      background: #cccccc;
      border-radius: 50%;
    }
    .van-swipe__indicator--active {
      width: 0.25rem;
      height: 0.07rem;
      background: #3c3c3c;
      border-radius: 0.04rem;
    }
  }
}
.ipad.gl .gameIntro_content {
  .van-swipe__indicators {
    top: 3.66rem;
  }
}
.lhlr .gameIntro_content {
  .van-swipe__indicators {
    height: 0.07rem;
    top: 3.44rem;
    .van-swipe__indicator {
      width: 0.07rem;
      height: 0.07rem;
      background: #cccccc;
      border-radius: 50%;
    }
    .van-swipe__indicator--active {
      width: 0.25rem;
      height: 0.07rem;
      background: #3c3c3c;
      border-radius: 0.04rem;
    }
  }
}
</style>